module.exports = __webpack_public_path__ + "static/img/down_bg.7d728f59.png";